export default __webpack_public_path__ + "static/media/5_image_5.2248b9e5.jpg";